import { getJSON } from 'api/utils/requests';

export default {
  check: getJSON('/auth/check'),
  authenticate: getJSON('/auth/authenticate'),
  finalize: getJSON('/auth/finalize'),
};
